import { useRef } from "react";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import { useSelector } from "react-redux";
import { RootStateType } from "storeRedux/store";




export  const avatarParts: MeshProps[] = [
    {
        name: "head",
        type: "box",
        position: [0, 1.2, 0],
        scale: [0.35, 0.35, 0.35],
        color: "#ffdbac",
    },
    {
        name: "right-eye",
        type: "box",
        position: [0.08, 1.25, 0.16],
        scale: [0.06, 0.06, 0.04],
        color: "#000000",
    },
    {
        name: "left-eye",
        type: "box",
        position: [-0.08, 1.25, 0.16],
        scale: [0.06, 0.06, 0.04],
        color: "#000000",
    },
    {
        name: "torso",
        type: "box",
        position: [0, 0.75, 0],
        scale: [0.5, 0.6, 0.4],
        color: "#00f3f7",
    },
    // الأطراف المتحركة يتم ربطها بالـ Ref المقابل ولها أبعاد الـ Group الداخلي
    {
        name: "right-arm",
        type: "box",
        position: [0.33, 0.7, 0], // موقع نقطة المحور (Pivot)
        scale: [0.14, 0.5, 0.16],
        color: "#00f3ff",
    },
    {
        name: "left-arm",
        type: "box",
        position: [-0.33, 0.7, 0],
        scale: [0.14, 0.5, 0.16],
        color: "#00f3ff",
    },
    {
        name: "right-leg",
        type: "box",
        position: [0.16, 0.225, 0],
        scale: [0.16, 0.5, 0.18],
        color: "#1a1a1a",
    },
    {
        name: "left-leg",
        type: "box",
        position: [-0.16, 0.225, 0],
        scale: [0.16, 0.5, 0.18],
        color: "#1a1a1a",
    }
];

export const AvatarPlayer = ({ isMoving = false,colors }: AvatarPlayerProps) => {
    
    const leftArmRef = useRef<THREE.Mesh>(null);
    const rightArmRef = useRef<THREE.Mesh>(null);
    const leftLegRef = useRef<THREE.Mesh>(null);
    const rightLegRef = useRef<THREE.Mesh>(null);

    const {user} = useSelector((state:RootStateType)=>state.auth);

    useFrame((state) => {
        if (isMoving) {
            const time = state.clock.getElapsedTime() * 8;
            const angle = Math.sin(time) * 0.6; 

            if (leftArmRef.current) leftArmRef.current.rotation.x = angle;
            if (rightArmRef.current) rightArmRef.current.rotation.x = -angle;
            if (leftLegRef.current) leftLegRef.current.rotation.x = -angle * 0.8;
            if (rightLegRef.current) rightLegRef.current.rotation.x = angle * 0.8;
        } else {
            if (leftArmRef.current) leftArmRef.current.rotation.x = 0;
            if (rightArmRef.current) rightArmRef.current.rotation.x = 0;
            if (leftLegRef.current) leftLegRef.current.rotation.x = 0;
            if (rightLegRef.current) rightLegRef.current.rotation.x = 0;
        }
    });


    const refs: Record<string, React.RefObject<THREE.Mesh | null>> = {
        "right-arm": rightArmRef,
        "left-arm": leftArmRef,
        "right-leg": rightLegRef,
        "left-leg": leftLegRef,
    };

  const getPartColor = (partName: string): string => {
        if (!colors) {
            const fallbackPart = avatarParts.find(p => p.name === partName);
            return fallbackPart ? fallbackPart?.color || "#ffffff":"#ffffff";
        }

        if (partName === "head") return colors.head || "#ffdbac";
        if (partName.includes("eye")) return colors.eyes || "#1a1a1a";
        if (partName === "torso") return colors.torso || "#00f3f7";
        if (partName.includes("arm")) return colors.arms || "#00f3ff";
        if (partName.includes("leg")) return colors.legs || "#1a1a1a";

        return "#ffffff";
    };

    return (
        <group name={"avatar-" + user?.id}>
            {avatarParts.map((part) => {
                const targetRef = refs[part.name];
                const finalColor = getPartColor(part.name); // جلب اللون المخصص أو الافتراضي بشكل دقيق

                return (
                    <mesh 
                        ref={targetRef ? (targetRef as any) : undefined} 
                        key={part.name + user?.id} 
                        position={part.position as [number, number, number]}
                    >
                        <boxGeometry args={part.scale as [number, number, number]} />
                        <meshStandardMaterial color={finalColor} />
                    </mesh>
                );
            })}
        </group>
    );
};